import { CONFIRM_COLOR, CONFIRM_ICONS, TYPE_MODAL } from '../modal-confirm-notification';

export const RETURN_ROUTE = {
    typeModal: TYPE_MODAL.NOTIFICATION,
    title: '¿Está seguro que desea generar las rutas integrales de devolución?',
    valueButton: 'Generar',
    color: CONFIRM_COLOR.SUCCESS,
    iconSVG: CONFIRM_ICONS.SAVE
  };
